"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.programsLogos = void 0;
const programs_1 = require("../types/programs");
const dekalb_integrado_logo_png_1 = __importDefault(require("../assets/dekalb-integrado-logo.png"));
const fieldview_advisor_logo_png_1 = __importDefault(require("../assets/fieldview-advisor-logo.png"));
const preceon_logo_png_1 = __importDefault(require("../assets/preceon-logo.png"));
const valora_logo_png_1 = __importDefault(require("../assets/valora-logo.png"));
exports.programsLogos = {
    [programs_1.Programs.DEKALB_INTEGRADO]: dekalb_integrado_logo_png_1.default,
    [programs_1.Programs.FIELDVIEW_ADVISOR]: fieldview_advisor_logo_png_1.default,
    [programs_1.Programs.PRECEON]: preceon_logo_png_1.default,
    [programs_1.Programs.VALORA]: valora_logo_png_1.default,
};
